import React from "react";
import PageBannerImage from "../../images/page-banner-digital-product.png";
import IconMaintenance from "../../icons/icon-maintenance.svg";
import IconStrategy from "../../icons/icon-strategy.svg";
import IconDesign from "../../icons/icon-design.svg";
import IconEngineering from "../../icons/icon-engineering.svg";
import IconTesting from "../../icons/icon-testing.svg";
import IconDelivery from "../../icons/icon-delivery.svg";
import IconCompetitiveAdvantage from "../../icons/icon-competitive-advantage.svg";
import IconProductIdea from "../../icons/icon-product-Idea.svg";
import IconCustomerAquisition from "../../icons/icon-customer-aquisition.svg";
import IconDiscoveryDesign from "../../icons/icon-discovery-design.svg";
import IconProductPrototyping from "../../icons/icon-product-prototyping.svg";
import IconUserResearch from "../../icons/icon-user-research.svg";
import IconVisualUXDesign from "../../icons/icon-visual-UX-Design.svg";
import IconBrandingDesignSystems from "../../icons/icon-branding-design-systems.svg";
import IconMobileApp from "../../icons/icon-mobile-app.svg";
import ImageMobileApp from "../../images/icon-mobile-app.svg";
import IconDiscover from "../../icons/icon-discover.svg";
import IconDecide from "../../icons/icon-decide.svg";
import IconValidate from "../../icons/icon-validate.svg";
import IconPrototype from "../../icons/icon-prototype.svg";
import IconIdeate from "../../icons/icon-ideate.svg";
import ProductBannerImage from "../../images/page-banner-salesmate.png";
import ImageUserJim from "../../images/profile-jim.jpg";
import ImageUserJohn from "../../images/profile-john.jpg";
import IconKinVelly from "../../images/icon-kinvelly.svg";
import IconPhysioOutcome from "../../images/icon-physiooutcome.svg";
import IconAccelerate from "../../icons/icon-accelerate.svg";
import IconIncreaseCustomer from "../../icons/icon-increase-customer.svg";
import IconReduceProduct from "../../icons/icon-reduce-product.svg";
import ImageDataAnalytics from "../../images/icon-data-analytics.svg";
import { Link } from "gatsby";

import ImageLastMile from "../../images/services-cs-lastmile.png";
import ImageSalesmateHalf from "../../images/service-cs-salesmate-half.jpg";
import ImageKrogerHalf from "../../images/service-cs-kroger-half.jpg";

export const webBlockQuoteObj = {
  classes: "md-blockquote",
  quote: "Many companies talk big game but fall short on delivery. Rapidops have literally done everything an enterprise needs to start from scratch and be the digital leader in their space. They are truly experts at their craft.",
  author: "Brian",
  occupation: "DIRECTOR, SALESMATE.IO",
};

export const mainBannerObj = {
  classes: "",
  title: "Digital Product Design",
  header: (<>Digital Product <br />Design</>),
  content: "Transform your business with ingenious and intuitive products that offer simple and engaging customer experiences, and deliver ROI.",
  mediaSource: PageBannerImage,
  mediaClass: "align-center",
  mediaType: "image"
};
export const pageIntroObj = {
  classes: "",
  title: "Monetize your Product Design",
  header: "Unleash your business’s full potential with world-class product experience & design",
  content: (<><p>The best companies in the world are all design-led. Facebook, Google, Amazon, Uber, Tesla are a few examples of companies designing amazing and engaging product experiences that continue to attract billions of users fueling their historic growth.</p>
    <p>At Rapidops, we are helping some of the world’s largest companies solve complex problems with purposeful product design. Our team has developed some of the most powerful experiences that connect physical and digital worlds enabling seamless customer journeys for millions across the web, mobile, IoT, and in-person interactions.</p>
    <p>With design-first thinking and over a decade long expertise, we discover and deliver customer-centric products that create happy customers, deliver business results, and reduce cost in as few as 4 weeks.</p>
  </>)
};

export const pageIntroObj2 = {
  classes: "",
  header: "Create winning products to turn your customers into brand advocates",
  content: (<><p>Launch compelling products that have the power to attract, acquire, retain customers with its impeccable design and meaningful interactions across all channels. Our team of experienced designers combines UX and UI design in a way that craft intuitive & usable digital products that provide maximum value to its users & your brand. With product design services from Rapidops, companies from various industries gain a competitive edge by delivering exceptional product experiences.</p>
    <p>Our design studio provides services for companies from various industries and at different stages of business development.</p></>)
};

export const pageIntroObj3 = {
  classes: "section-gap",
  header: "Taking more disruptive approach",
  content: (<><p>Not every solution can be off-the-shelf, which helps you transform your processes and work-flows. You need an enterprise-scale application that is built from the ground up, has the engaging experience, flexibility, and scope of scalability that delivers results. If you have built your system over the years, we can modernize your software with progressive technology and new interface design to extend the life span.</p></>)
};

export const introColumnObj = {
  classes: "",
  header: "our analytics expertise",
  subHeader: "Monetize your growing data with our advanced analytics, and AI/ML expertise in less than 4 weeks.",
  intro: (<><p>Transform your processes, people, products, services and conversations using actionable intelligence with our premium data analytics, AI and machine learning services</p></>),
};

export const threeColSliderObj = {
  classes: " ",
  header: "Create winning products & brand",
  subHeader: "Use empathy, research, and expertise to monetize your design opportunity",
  items: [
    {
      icon: <IconProductIdea />,
      header: "Validate Your Product Idea",
      content: "Discover the product, prototype it, and validate it with potential users and investors to eliminate the risk of building the wrong product."
    }, {
      icon: <IconCustomerAquisition />,
      header: "Accelerate Customer Aquisition",
      content: "Launch amazing products that speak for itself and draws more leads, sales and referrals to fuel the customer and revenue growth."
    }, {
      icon: <IconCompetitiveAdvantage />,
      header: "Improve Competitive Advantage",
      content: "Create intuitive and easy-to-use experiences that compel customers to choose your product over clunky competitors and stay loyal."
    }, {
      icon: <IconAccelerate />,
      header: "Accelerate Product Adoption Rate",
      content: "Make it easier for new customers to understand, use and adapt your product to boost user activation to attain your business goals."
    }, {
      icon: <IconIncreaseCustomer />,
      header: "Increase Customer Satisfaction",
      content: "Enable customers to be productive and satisfied with the well-crafted product that solves their problems without getting into their way."
    }, {
      icon: <IconReduceProduct />,
      header: "Reduce Product Support Costs",
      content: "Build products that are so easy to understand and use that customers can be self-sufficient and requires minimal interactions with the support team."
    }
  ]
};
export const gridlayoutObj = {
  classes: "two-row-three-col-grid",
  header: "OUR DIGITAL PRODUCT EXPERTISE",
  subHeader: "Get, grow, and engage customers with its breathtaking design and interactions",
  gridItems: [
    {
      icon: <IconDiscoveryDesign />,
      header: "Discovery by Design",
      content: "Identify opportunities to increase revenue, reduce costs, and increase customer satisfaction with immersive design workshops and data-driven analysis."
    },
    {
      icon: <IconUserResearch />,
      altText: "User Research",
      header: "User Research",
      content: "Understand your user’s needs, journeys, and behaviors. Learn to think like them to design the form and function that exceeds their expectations."
    },
    {
      icon: <IconProductPrototyping />,
      header: "Product Prototyping",
      content: "Rapidly create interactive prototypes (they do feel like real products) to validate product ideas with users and market feedback or pitch to investors."
    },
    {
      icon: <IconVisualUXDesign />,
      header: "Visual & UX Design",
      content: "Combine user research, design principles, and technology to produce meaningful interactions and interfaces that enrich the entire user journey."
    },
    {
      icon: <IconBrandingDesignSystems />,
      header: "Branding & Design Systems",
      content: "Create a re-usable and consistent design framework that includes UX patterns, UI elements, typography, icons, and colors to use them across many products & apps."
    }
  ],
  getStarted: {
    header: "Let's get started",
    content: "Have a project for us?  Book a free consultation.",
    link: <Link to="/contact/" className="button button-small button-black right-arrow">Contact Us</Link>
  }
};

export const columnLayoutObj = {
  classes: "",
  header: "Checkout our other services",
  subHeader: (<></>),
  services: [
    {
      icon: <IconMobileApp />,
      image: ImageMobileApp,
      header: "Mobile App Development",
      content: "Build iOS, Android, and React Native apps that deliver outstanding experiences.",
      link: "/services/mobile-app-development/"
    }, {
      image: ImageDataAnalytics,
      alt: "data analytics services",
      title: "Data Analytics",
      header: "Data Analytics",
      content: "Grow your business with actionable intelligence and data-driven products.",
      link: "/services/data-analytics/"
    }
  ]
};

export const testimonialSliderObj = {
  classes: "",
  title: <>We've shipped award-winning digital products for our clients</>,
  header: "",
  link: "/",
  items: [
    {
      content: "Rapidops is one of the few teams that deeply understand their users and design apps that have both form and function.",
      userImage: ImageUserJim,
      userImageAlt: "Jim Donnelly",
      userImageTitle: "Jim Donnelly",
      authorName: "Jim Donnelly",
      authorOccupation: "Co-founder, Kinvalley",
      logo: IconKinVelly,
      logoAlt: "Kin Valley",
      logoTitle: "Kin Valley"
    }, {
      content: "Beautiful experience and robust engineering that what I hired Rapidops for, and they exceed my imagination and expectation on every scale.",
      userImage: ImageUserJohn,
      userImageAlt: "John Paul",
      userImageTitle: "John Paul",
      authorName: "John Paul",
      authorOccupation: "Founder, Physio Outcomes",
      logo: IconPhysioOutcome,
      logoAlt: "PhysioOutcome",
      logoTitle: "PhysioOutcome"
    }
  ]
};

export const pageFeatureBannerObj = {
  classes: "",
  header: "Salesmate",
  subHeader: "The sales CRM made for you",
  content: <>Organize your sales process, win more deals, and create <br />happy customers with our automated sales CRM.</>,
  link: <Link to="/work/salesmate-sales-crm/" className="button button-white-blue">View Case Study</Link>,
  imageIsInsideRow: true,
  image: ProductBannerImage,
  alt: "custom web application development",
  title: "Web Application Development"
};

export const processFlowObj = {
  classes: "",
  title: "agile software development",
  header: "Proven and battle-tested process",
  subHeader: "With 11 years and 200+ products, we’ve battle-tested our approach to products, people, and processes. From vision to strategy to a roadmap to delivery and beyond, we go end-to-end; no other vendor needed to fill the gaps. We stay lean, move fast, and deliver tangible product in weeks (not the $50,000 PPT or vaporware).",
  items: [
    {
      class: "process-item border-bottom",
      icon: <IconStrategy />,
      name: "Strategy"
    },
    {
      class: "process-item border-right",
      icon: <IconDesign />,
      name: "Design"
    },
    {
      class: "process-item border-right border-bottom",
      icon: <IconEngineering />,
      name: "Engineering"
    },
    {
      class: "process-item",
      icon: <IconTesting />,
      name: "Testing"
    },
    {
      class: "process-item border-right border-top-right-radius",
      icon: <IconDelivery />,
      name: "Delivery"
    },
    {
      class: "process-item",
      icon: <IconMaintenance />,
      name: "Maintenance"
    }
  ]
};

export const designSprintObj = {
  classes: "",
  title: "Our product design expertise",
  header: "Design Sprints",
  subHeader: "Transform your vision into a validated product strategy and design in less than 2 weeks.",
  items: [
    {
      icon: <IconDiscover />,
      name: "Discover"
    },
    {
      icon: <IconIdeate />,
      name: "Ideate"
    },
    {
      icon: <IconDecide />,
      name: "Decide"
    },
    {
      icon: <IconPrototype />,
      name: "Prototype"
    },
    {
      icon: <IconValidate />,
      name: "Validate"
    }
  ]
};



export const succesStoriesObj = {
  classesForFullColumn: "cs-lastmile",
  imageForFullColumn: ImageLastMile,
  imageAltForFullColumn: "last-mile-automation",
  imageTitleForFullColumn: "Last Mile Automation",
  categoryForFullColumn: "logistics",
  headerForFullColumn: "Reinventing last mile delivery",
  subHeaderForFullColumn: (<>How we helped a manufacturing giant to optimize and automate last mile delivery & customer experiences?</>),
  linkForFullColumn: '/work/last-mile-automation/',

  classesForhalfColumn1: "cs-kroger-hlaf",
  imageForHalfColumn1: ImageKrogerHalf,
  imageAltForHalfColumn1: "custom voice automation retail",
  imageTitleForHalfColumn1: "Custom Voice Automation",
  categoryForHalfColumn1: "Retail",
  headerForHalfColumn1: "Voice-enabled shopping",
  linkForForHalfColumn1: '/work/kroger-grocery-shopping-voice-assistant/',

  classesForhalfColumn2: "cs-salesmate-hlaf",
  imageForHalfColumn2: ImageSalesmateHalf,
  imageAltForHalfColumn2: "Salesmate CRM Dashboard",
  imageTitleForHalfColumn2: "crm dashboard",
  categoryForHalfColumn2: "CRM",
  headerForHalfColumn2: "Salesmate",
  linkForForHalfColumn2: '/work/salesmate-sales-crm/',
};


export const ctaObj = {
  title: <>Let’s discuss your digital opportunity.</>,
  subtitle: "Unlock your digital transformation opportunities now!",
};